import { useQuery } from "@tanstack/react-query";
import axios from "../helpers/axios";
import { GameResponse, HomeData } from "./dtos/home.dto";

export const useHomeData = () => {
  return useQuery({
    queryKey: ["home_data"],
    queryFn: async () => {
      const res = await axios.get<GameResponse[]>("/user/games");

      const games = res.data
        .filter((game) => game.active && !game.disabled)
        .sort((a, b) => a.orders - b.orders);

      const banners = games
        .filter((game) => game.bannerImage)
        .map((game) => ({
          id: game.id.toString(),
          imageUrl: game.bannerImage!,
          redirectUrl: game.url,
        }));

      const recommendedGames = games
        .filter((game) => game.recommended && game.recommendImage)
        .map((game) => ({
          id: game.id.toString(),
          title: game.name,
          imageUrl: game.recommendImage!,
          redirectUrl: game.url,
        }));

      const regularGames = games.map((game) => ({
        id: game.id.toString(),
        title: game.name,
        imageUrl: game.cardImage,
        redirectUrl: game.url,
      }));

      const homeData: HomeData = {
        banners,
        recommendedGames,
        games: regularGames,
      };

      return homeData;
    },
    retry: 1,
    staleTime: 5 * 60 * 1000,
  });
};
